var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],class:"status-indicator status-" + _vm.status,attrs:{"alt":_vm.status,"hover":"","title":_vm.status}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }